// base styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";
import boxShadows from "assets/mavric-theme/base/boxShadows";

// helper functions
// import rgba from "assets/mavric-theme/functions/rgba";
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import linearGradient from "assets/mavric-theme/functions/linearGradient";

const { secondary, gradients, grey, transparent, primary, white } = colors;
const { borderWidth } = borders;
const { md } = boxShadows;

const switchButton = {
  defaultProps: {
    disableRipple: false,
  },

  styleOverrides: {
    switchBase: {
      color: gradients.dark.main,

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-checked": {
        color: gradients.dark.main,

        "&:hover": {
          backgroundColor: transparent.main,
        },

        "& .MuiSwitch-thumb": {
          backgroundColor: secondary.main,
          //border: `${borderWidth[1]} solid ${secondary.main}`,
        },

        "& + .MuiSwitch-track": {
          backgroundColor: grey[400],
          border: `${borderWidth[1]} solid ${grey[400]}`,
          opacity: 1,
        },
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: "0.3 !important",
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        backgroundImage: linearGradient(gradients.info.main, gradients.info.state),
      },
    },

    thumb: {
      backgroundColor: white.main,
      boxShadow: md,
      borderColor: `${gradients.dark.main} !important`,
    },

    track: {
      width: pxToRem(32),
      height: pxToRem(15),
      backgroundColor: `${gradients.dark.main} !important`,
      borderColor: `${gradients.dark.main} !important`,
      opacity: 1,
    },

    checked: {},
  },
};

export default switchButton;
